export const INCOMPLETE_STUDENT_FLAG = "(Incomplete)";

export interface AcademyStudent {
	userId: string;
	platformId: string;
	firstName: string;
	lastName: string;
	campusId?: string;
	grade?: number;
}

export interface UninitializedStudent {
	platformId: string;
	firstName?: string;
	lastName?: string;
	displayName: string;
}

export interface StudentsByApp {
	academyStudents: AcademyStudent[];
	platformStudents: UninitializedStudent[];
}
